import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DesignRenderGroupServices } from "@/services/bedrock/DesignRenderGroupServices";
import { CreateRenderGroupRequest } from "@/services/bedrock/dtos/DesignRenderGroup";
import { designKeys } from "@/services/bedrock/queryKeys";

/**
 * Creates a personalized render, or gets back an identical recent one (`force` skips that reuse).
 * The group is cached right away so the preview shows it as pending without a fetch. No caption
 * job is asked for: the flow writes the caption itself, ahead of the render, and attaches it.
 */
export function useStartShare() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (req: CreateRenderGroupRequest & { force?: boolean }) => DesignRenderGroupServices.create(req),
    onSuccess: group => {
      queryClient.setQueryData(designKeys.renderGroup(group.id), group);
    },
  });
}
